import React from 'react';
import { X } from 'lucide-react';

const ModalHeader = ({ customerName, onClose }) => {
  return (
    <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
      <h2 className="m-0 text-xl text-gray-900">Schedule Meeting with {customerName}</h2>
      <button
        className="bg-transparent border-none cursor-pointer text-gray-500 p-1 rounded hover:bg-gray-100 hover:text-gray-900"
        onClick={onClose}
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default ModalHeader;